import { Box, Flex, Grid, Skeleton, createStyles } from '@mantine/core';
import type { FC } from 'react';

const useStyles = createStyles((theme) => ({
  grid: {
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  leftGridCol: {
    WebkitFlexBasis: `${(1 / 12) * 100}%`,
    flexBasis: `${(1 / 12) * 100}%`,
    maxWidth: `${(1 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(1 / 12) * 100}%`,
  },

  middleGridCol: {
    WebkitFlexBasis: `${(9 / 12) * 100}%`,
    flexBasis: `${(9 / 12) * 100}%`,
    maxWidth: `${(9 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(9 / 12) * 100}%`,
  },

  rightGridCol: {
    WebkitFlexBasis: `${(2 / 12) * 100}%`,
    flexBasis: `${(2 / 12) * 100}%`,
    maxWidth: `${(2 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,
  },
}));

const ItemsSkeleton: FC = () => {
  const { classes, cx } = useStyles();
  return (
    <Box
      w={'100%'}
      h={84}
      bg='white'
      style={{
        border: '0.0625rem solid #dee2e6',
        boxShadow:
          '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 0.75rem 0.75rem -0.4375rem',
        borderRadius: 20,
      }}>
      <Grid p={0} m={0} h={'100%'}>
        <Grid.Col className={cx(classes.grid, classes.leftGridCol)}>
          <Skeleton h={'100%'} w={'100%'} />
        </Grid.Col>
        <Grid.Col className={cx(classes.grid, classes.middleGridCol)}>
          <Skeleton h={18} w={'100%'} />
          <Flex gap={4} mt={16}>
            <Skeleton h={18} w={'50%'} />
            <Skeleton h={18} w={'50%'} />
          </Flex>
        </Grid.Col>
        <Grid.Col className={cx(classes.grid, classes.rightGridCol)}>
          <Flex gap={16} direction='column'>
            <Skeleton h={18} w={'100%'} />
            <Skeleton h={18} w={'100%'} />
          </Flex>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default ItemsSkeleton;
